import Wrapper from '@/components/shared/Wrapper';
import { StyledProp, styled } from '@/styled';

import CarouselOffers from './CarouselOffers';
import CourseShelf from './Shelves/Course';
import KeepLearningShelf from './Shelves/KeepLearning';
import RecentlySavedShelf from './Shelves/RecentlySaved';

const Showcase: React.FC = (props: StyledProp) => {
  return (
    <>
      <CarouselOffers />
      <Wrapper {...props}>
        <KeepLearningShelf />
        <RecentlySavedShelf />
        <CourseShelf />
      </Wrapper>
    </>
  );
};

export default styled(Showcase)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space.spacing(16)};
`;
